class Signal {
  #signalCallbacks;

  constructor() {
    this.#signalCallbacks = {};
  }

  send(name, params = {}) {
    if (this.#signalCallbacks[name] === undefined) return;
    this.#signalCallbacks[name].forEach(callback => callback(params));
  }

  // [NOTE] Use 'arrow function' as a callback function to retain the lexical context's 'this' value, not the execution context's 'this'.
  addListener(name, callback) {
    if (typeof callback !== "function") return;
    if (this.#signalCallbacks[name] === undefined) this.#signalCallbacks[name] = [];
    this.#signalCallbacks[name].push(callback);
  }

  removeListener(name, callback) {
    if (this.#signalCallbacks[name] === undefined) return;
    const idx = this.#signalCallbacks[name].indexOf(callback);
    if (idx !== -1) this.#signalCallbacks[name].splice(idx, 1);
  }
}

export default Object.freeze(Signal);
